'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UILink from 'UIComponents/link/UILink';
import { CTA_PERFORMANCE, LanguageCTALinks } from '../../constants/TrialConstants';
import ResultHeaderIllustration from './ResultHeaderIllustration';
import ResultSection from './ResultSection';
import PageScore from '../PageScore';
import Subtitle from '../Subtitle';
import ScoreConstants from '../../constants/ScoreConstants';
import PerformanceData from '../../data/PerformanceData';
import ResultCtaBanner from '../ResultCtaBanner';
import { parseUtmParams } from '../../util/Urls';
var CTAButton = /*#__PURE__*/memo(function () {
  var lang = window.I18N_MANUAL_LANG;
  var alt = lang !== 'en' ? '-alt' : '';
  var url = lang !== 'en' ? LanguageCTALinks[lang] : CTA_PERFORMANCE;
  var parsedUtmParams = parseUtmParams();
  return /*#__PURE__*/_jsx(UILink, {
    href: url + "&" + parsedUtmParams,
    external: true,
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "results.performance.cta.button" + alt
    })
  });
});

var PerformancePage = function PerformancePage(_ref) {
  var websiteGrade = _ref.websiteGrade;
  var grade = websiteGrade.get('performanceAudit').get('grade');
  return /*#__PURE__*/_jsx("div", {
    className: "full-page-centered performance-page",
    id: "performance",
    "data-reagan-selector": "performance-page",
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("div", {
        className: "wsg-container",
        children: [/*#__PURE__*/_jsx(ResultHeaderIllustration, {
          name: "design-manager"
        }), /*#__PURE__*/_jsx(PageScore, {
          score: grade,
          overallScore: ScoreConstants.PERFORMANCE_OVERALL
        }), /*#__PURE__*/_jsx("h3", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.performance.title"
          })
        }), /*#__PURE__*/_jsx(Subtitle, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.performance.description"
          })
        }), /*#__PURE__*/_jsx(ResultCtaBanner, {
          use: "trophy",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "results.performance.cta.info",
            options: {
              ctaButton: /*#__PURE__*/_jsx(CTAButton, {})
            }
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "results-section radial-results-section",
          children: /*#__PURE__*/_jsx(ResultSection, {
            websiteGrade: websiteGrade,
            results: PerformanceData.topResults
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "results-section",
          children: /*#__PURE__*/_jsx(ResultSection, {
            websiteGrade: websiteGrade,
            results: PerformanceData.middleResults
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "results-section bottom-results",
          children: /*#__PURE__*/_jsx(ResultSection, {
            websiteGrade: websiteGrade,
            results: PerformanceData.bottomResults
          })
        })]
      })
    })
  });
};

export default PerformancePage;